import { HTTP } from "api";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      foo: "Foo",
    },
  },
};

export const languages = [
  {
    langId: 1,
    cultureCode: "en-US",
    cultureDescription: "English",
    langEnabled: true,
  },
  {
    langId: 2,
    cultureCode: "it-IT",
    cultureDescription: "Italiano",
    langEnabled: true,
  },
  {
    langId: 3,
    cultureCode: "fr-FR",
    cultureDescription: "Français",
    langEnabled: true,
  },
  {
    langId: 4,
    cultureCode: "de-DE",
    cultureDescription: "Deutsch",
    langEnabled: true,
  },
  {
    langId: 5,
    cultureCode: "it-CH",
    cultureDescription: "Ponera",
    langEnabled: true,
  },
];

export const loadTranslations = (lang, cb) => {
  var l = sessionStorage.getItem("__appLang");

  HTTP.get("Globalization")
    .then((response) => {
      resources[lang] = { translation: response.data };

      i18next.use(initReactI18next).init({
        resources,
        lng: lang,
        interpolation: {
          escapeValue: false,
        },
      });

      cb();
    })
    .catch((error) => {
      console.log(error);
    });
};

/*export function fullDate(d) {
  let lang = 'en-US';

  switch (i18next.language) {
    case 'en':
      lang = 'en-US'
      break;
    default:
      lang = i18next.language + '-' + i18next.language.toLocaleUpperCase()
      break;
  }

  var options = {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: 'numeric', minute: 'numeric', second: 'numeric',
    hour12: false
  }

  return new Intl.DateTimeFormat(lang, options).format(d)
}*/
